import { trans } from 'Rentlio/helper/translation'
import { getCardNumberIssuer } from 'Rentlio/utils/cardNumber'

export function cardNumberConstraint(cardNumber) {
  if (typeof cardNumber === 'undefined' || cardNumber === null || cardNumber === '') {
    return
  }
  return getCardNumberIssuer(cardNumber) === null ? trans('This is not supported card number') : null
}
